/**
 * Per-context "last viewed conversation" tracking. Used by
 * DatasetAssistantV2 to restore the most recent conversation when the
 * user re-enters a dataset within the same SPA session.
 */

const activeIds = new Map<string, string>();

/** Get the last-viewed conversation ID for a given context (e.g. dataset). */
export function getActiveConversationId(contextId: string): string | null {
  return activeIds.get(contextId) ?? null;
}

/** Remember which conversation was last viewed for a context. */
export function setActiveConversationId(contextId: string, conversationId: string | null): void {
  if (conversationId) {
    activeIds.set(contextId, conversationId);
  } else {
    activeIds.delete(contextId);
  }
}
